var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTheDealFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.002 15.46c.767.26 1.55.462 2.47.277 3.588-.715 4.557-8.309.456-8.946l-2.926 8.669zM7.693 16.648c.045.22.307.382.775.29.59-.119.824-.38 1.01-.803-.401-.076-.809-.11-1.248-.022-.412.083-.577.33-.537.535z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm-.056-16.524c4.59-.918 6.323 2.735 5.8 6.127.01.79-.612 2.034-.612 2.034-.705 1.51-1.922 2.718-3.583 3.049-1.308.262-2.285-.063-3.171-.364-.491.951-1.202 1.44-2.095 1.619-1.197.24-1.94-.365-2.09-1.117-.13-.647.199-1.416 1.095-1.813a3.17 3.17 0 01.29-.108l.014-.005a2.822 2.822 0 01.15-.042l.01-.003a3.207 3.207 0 01.595-.088c.432-.022.842.048 1.243.153l.097-.309 2.745-8.073c-.035.007-.07.01-.106.014-.036.003-.071.007-.106.014-.369.073-.73.175-1.071.305l-.007.002a.036.036 0 01-.007.002l-.14.057-.02.008-.055.024a4.333 4.333 0 00-.207.094l-.041.02-.04.02-.088.045-.018.01a.252.252 0 00-.006.003c-3.51 1.866-2.816 6.652-2.816 6.652-1.412-3.877.264-7.535 4.24-8.33z",
    fill: "currentColor"
  })));
}
SvgTheDealFilled.displayName = 'TheDealFilled';
export default SvgTheDealFilled;